export default "__VITE_ASSET__74329528__$_?nuxt_component=async__"